import { render } from "./SaleCartDetailsModal.vue?vue&type=template&id=63b6d58c&scoped=true"
import script from "./SaleCartDetailsModal.vue?vue&type=script&lang=js"
export * from "./SaleCartDetailsModal.vue?vue&type=script&lang=js"

import "./SaleCartDetailsModal.vue?vue&type=style&index=0&id=63b6d58c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b6d58c"]])

export default __exports__